import React from 'react';
import { Helmet } from 'react-helmet';
import './About.css';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About — Jericho F.</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="About Jericho F., Data Scientist." />
      </Helmet>
      <section className="about">
        <div className="about-inner">
          <h1 className="page-title">About</h1>

          <p className="about-bio">
            Data Scientist with experience in web development. I analyze large datasets,
            build data pipelines, and create data-driven insights.
          </p>

          <div className="about-section">
            <span className="section-label">Skills</span>
            <div className="skills-table">
              <div className="skill-row">
                <span className="skill-category">Data</span>
                <span className="skill-items">Python · Pandas · SQL · Spark · Scala</span>
              </div>
              <div className="skill-row">
                <span className="skill-category">Tools</span>
                <span className="skill-items">Jupyter · Git · VS Code</span>
              </div>
              <div className="skill-row">
                <span className="skill-category">Web</span>
                <span className="skill-items">React · JavaScript · CSS</span>
              </div>
            </div>
          </div>

          <div className="about-section">
            <span className="section-label">Education</span>
            <div className="edu-row">
              <span className="edu-degree">Computer Science</span>
              <span className="edu-level">Bachelor's Degree</span>
            </div>
          </div>

          <div className="about-section">
            <span className="section-label">Languages</span>
            <p className="lang-list">English · Chinese · Malay</p>
          </div>

        </div>
      </section>
    </>
  );
};

export default About;
